import React, { useState, useEffect } from 'react';
import UpgradeModal from './UpgradeModal';
import axios from 'axios';

/**
 * Global plan error interceptor. Catches 403 responses with plan_limit_reached
 * or feature_not_available errors and shows the upgrade modal automatically.
 * Mount this once at the App level.
 */
export default function PlanErrorInterceptor() {
    const [open, setOpen] = useState(false);
    const [triggerResource, setTriggerResource] = useState(null);
    const [triggerFeature, setTriggerFeature] = useState(null);

    useEffect(() => {
        const interceptor = axios.interceptors.response.use(
            (response) => response,
            (error) => {
                const detail = error?.response?.data?.detail;
                if (error?.response?.status === 403 && detail && typeof detail === 'object') {
                    if (detail.error === 'plan_limit_reached') {
                        setTriggerResource(detail.resource);
                        setTriggerFeature(null);
                        setOpen(true);
                    } else if (detail.error === 'feature_not_available') {
                        setTriggerFeature(detail.feature);
                        setTriggerResource(null);
                        setOpen(true);
                    }
                }
                return Promise.reject(error);
            }
        );
        return () => axios.interceptors.response.eject(interceptor);
    }, []);

    return (
        <UpgradeModal
            open={open}
            onClose={() => { setOpen(false); setTriggerResource(null); setTriggerFeature(null); }}
            triggerResource={triggerResource}
            triggerFeature={triggerFeature}
        />
    );
}
